import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { theme } from '@components-shared/src/stitches';
import { Button } from '@components/main-components/button/Button';
import { SamFaq } from '@components/modals/Faq/SamFaq';
import { ModalContext, ModalType } from '@context/modal';
import { formatWeiToEthForDisplay } from '@utils/helpers';

export function BondingCurveFaqButton({
  milestonePriceInWei,
  tokensToMilestone,
}: {
  milestonePriceInWei: string;
  tokensToMilestone: number;
}) {
  const { openModal } = ModalContext.useContainer();

  const ethValue = formatWeiToEthForDisplay({ weiValue: milestonePriceInWei });

  const onFaqButtonClick = () => {
    openModal(ModalType.SAM_FAQ, {
      body: <SamFaq />,
    });
  };

  return (
    <Button
      variant="text"
      fullWidth
      label={`Increases to ${ethValue} ETH after ${tokensToMilestone} more mints`}
      trailingIcon={<FontAwesomeIcon icon={faChevronRight} color={theme.colors.base500.value} />}
      onClick={onFaqButtonClick}
      size="M"
      className="mt-2 font-base text-base-s text-base800"
    />
  );
}
